import ArrivalSection from './ArrivalSection'

export default ArrivalSection
